import axios from 'axios'

const env = (process.env.NODE_ENV === 'production')

const config = () => {
  return {
    url: env ? 'https://fdc-api.brique.kr' : 'http://localhost',
    port: env ? '' : ':'.concat('20004'),
    service: '/fdc/collection'
  }
}

export default {
  /**
   * EQP Context Info, Data Collection Plan
   */
  getCollectionPlans: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/collection-plans', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  getSyncCollectionPlans: (payload) => {
    return axios.get(config().url + config().port + config().service + '/collection-plans', { params: payload })
      .catch(ex => {
        console.log(ex)
      })
  },
  getContextPlans: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/context-plans', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  addContextPlans: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + config().service + '/context-plans', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  // FIXME: REST DELETE로 수정 필요, 미사용중
  deleteContextPlans: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + config().service + '/context-plans/delete', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * Data Collection Plan
   */
  addCollectionPlan: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + config().service + '/collection-plan', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  putCollectionPlan: async (payload) => {
    try {
      let response = await axios.put(config().url + config().port + config().service + '/collection-plan', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  runCollectionPlan: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + config().service + '/collection-plan/exec/' + payload.execCmd + '/' + payload.execType, payload.listDCPlan)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  getEventPlans: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/event-plans', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  getTracePlans: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/trace-plans', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * Data Summary Plan
   */
  saveSummaryPlan: async (savePlanData) => {
    try {
      return await axios.post(config().url + config().port + config().service + '/summary-plan', savePlanData)
    } catch (error) {
      console.log(error)
    }
  },
  getSummaryPlanParams: async (params) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/summary-plan/params', { params: params })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  getSummaryPlanRecipes: async (params) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/summary-plan/recipes', { params: params })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  getSummaryPlanTypes: async (params) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/summary-plan/types', { params: params })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * Analysis
   */
  getSummaryPlanParamsString: async (params) => {
    console.log('getSummaryParamNameList')
    try {
      let response = await axios.get(config().url + config().port + config().service + '/summary-plan/params/string', { params: params })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  getSummaryPlanRecipesString: async (params) => {
    console.log('getSummaryRecipeStepNameList')
    try {
      let response = await axios.get(config().url + config().port + config().service + '/summary-plan/recipes/string', { params: params })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  getSummaryPlanTypesString: async (params) => {
    console.log('getSummaryTypeNameList')
    try {
      let response = await axios.get(config().url + config().port + config().service + '/summary-plan/types/string', { params: params })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  }
}
